export var ActionKind;
(function (ActionKind) {
    ActionKind["Create"] = "CREATE";
    ActionKind["Change"] = "CHANGE";
    ActionKind["Delete"] = "DELETE";
    ActionKind["Move"] = "MOVE";
    ActionKind["Lock"] = "LOCK";
    ActionKind["Unlock"] = "UNLOCK";
    ActionKind["Grouping"] = "GROUPING";
    ActionKind["Ungrouping"] = "UNGROUPING";
    ActionKind["GoodSet"] = "GOOD_SET";
    ActionKind["GoodCancel"] = "GOOD_CANCEL";
    ActionKind["Erase"] = "ERASE";
    ActionKind["PageCreate"] = "PAGE_CREATE";
    ActionKind["CreateFromClipboard"] = "CREATE_FROM_CLIPBOARD";
})(ActionKind || (ActionKind = {}));
export var CollaborationMode;
(function (CollaborationMode) {
    CollaborationMode["On"] = "ON";
    CollaborationMode["Off"] = "OFF";
})(CollaborationMode || (CollaborationMode = {}));
export var EventObjectKind;
(function (EventObjectKind) {
    EventObjectKind["Pen"] = "PEN";
    EventObjectKind["Text"] = "TEXT";
    EventObjectKind["Shape"] = "SHAPE";
    EventObjectKind["Title"] = "TITLE";
    EventObjectKind["Table"] = "TABLE";
    EventObjectKind["Picture"] = "PICTURE";
    EventObjectKind["Illustration"] = "ILLUSTRATION";
    EventObjectKind["Snapshot"] = "SNAPSHOT";
    EventObjectKind["Background"] = "BACKGROUND";
    EventObjectKind["Group"] = "GROUP";
    EventObjectKind["Sticky"] = "STICKY";
    EventObjectKind["None"] = "NONE";
})(EventObjectKind || (EventObjectKind = {}));
export var GoodButtonMode;
(function (GoodButtonMode) {
    GoodButtonMode["Set"] = "SET";
    GoodButtonMode["Cancel"] = "CANCEL";
})(GoodButtonMode || (GoodButtonMode = {}));
export var ImageObjectKind;
(function (ImageObjectKind) {
    ImageObjectKind["Picture"] = "PICTURE";
    ImageObjectKind["Snapshot"] = "SNAPSHOT";
    ImageObjectKind["Illustration"] = "ILLUSTRATION";
})(ImageObjectKind || (ImageObjectKind = {}));
export var NoteSort;
(function (NoteSort) {
    NoteSort["Title"] = "TITLE";
    NoteSort["CreatedDatetime"] = "CREATED_DATETIME";
    NoteSort["UpdatedDatetime"] = "UPDATED_DATETIME";
})(NoteSort || (NoteSort = {}));
export var ObjectKind;
(function (ObjectKind) {
    ObjectKind["Pen"] = "PEN";
    ObjectKind["Text"] = "TEXT";
    ObjectKind["Shape"] = "SHAPE";
    ObjectKind["Title"] = "TITLE";
    ObjectKind["Table"] = "TABLE";
    ObjectKind["Picture"] = "PICTURE";
    ObjectKind["Illustration"] = "ILLUSTRATION";
    ObjectKind["Snapshot"] = "SNAPSHOT";
    ObjectKind["Background"] = "BACKGROUND";
    ObjectKind["Group"] = "GROUP";
    ObjectKind["Sticky"] = "STICKY";
    ObjectKind["Several"] = "SEVERAL";
    ObjectKind["None"] = "NONE";
})(ObjectKind || (ObjectKind = {}));
export var Order;
(function (Order) {
    Order["Asc"] = "ASC";
    Order["Desc"] = "DESC";
})(Order || (Order = {}));
export var PageGroupType;
(function (PageGroupType) {
    PageGroupType["Normal"] = "NORMAL";
    PageGroupType["Reserve"] = "RESERVE";
    PageGroupType["RecycleBin"] = "RECYCLE_BIN";
})(PageGroupType || (PageGroupType = {}));
export var PageSize;
(function (PageSize) {
    PageSize["NoteVertical"] = "NOTE_VERTICAL";
    PageSize["NoteHorizontal"] = "NOTE_HORIZONTAL";
    PageSize["MozoushiVertical"] = "MOZOUSHI_VERTICAL";
    PageSize["MozoushiHorizontal"] = "MOZOUSHI_HORIZONTAL";
})(PageSize || (PageSize = {}));
export var ShuffleMode;
(function (ShuffleMode) {
    ShuffleMode["On"] = "ON";
    ShuffleMode["Off"] = "OFF";
})(ShuffleMode || (ShuffleMode = {}));
export var SingleObjectKind;
(function (SingleObjectKind) {
    SingleObjectKind["Pen"] = "PEN";
    SingleObjectKind["Text"] = "TEXT";
    SingleObjectKind["Shape"] = "SHAPE";
    SingleObjectKind["Title"] = "TITLE";
    SingleObjectKind["Table"] = "TABLE";
})(SingleObjectKind || (SingleObjectKind = {}));
export var Stamp;
(function (Stamp) {
    Stamp["VeryGood"] = "VERY_GOOD";
    Stamp["Good"] = "GOOD";
    Stamp["Fight"] = "FIGHT";
    Stamp["VeryWellDone"] = "VERY_WELL_DONE";
    Stamp["WellDone"] = "WELL_DONE";
    Stamp["DoOurBest"] = "DO_OUR_BEST";
    Stamp["None"] = "NONE";
})(Stamp || (Stamp = {}));
export var TemplateCategory;
(function (TemplateCategory) {
    TemplateCategory["Thinking"] = "THINKING";
    TemplateCategory["Plain"] = "PLAIN";
    TemplateCategory["Line"] = "LINE";
    TemplateCategory["Worksheet"] = "WORKSHEET";
})(TemplateCategory || (TemplateCategory = {}));
export var WorksheetKind;
(function (WorksheetKind) {
    WorksheetKind["Japanese"] = "JAPANESE";
    WorksheetKind["Arithmetic"] = "ARITHMETIC";
    WorksheetKind["Science"] = "SCIENCE";
    WorksheetKind["Social"] = "SOCIAL";
    WorksheetKind["English"] = "ENGLISH";
    WorksheetKind["Other"] = "OTHER";
})(WorksheetKind || (WorksheetKind = {}));
//# sourceMappingURL=types.js.map